import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, Box } from "@material-ui/core";
import PropTypes from "prop-types";
import { translate as t } from "../../../../../../infrastructure/translate/localization";

import useStyles from "./styles";

export const PaymentRow = ({ category, text, price, date }) => {
  const { row, iconBox } = useStyles();
  const getIcon = (str) =>
    ({
      "education-benefit": "book-reader",
      "nursery-benefit": "baby-carriage",
      "meal-benefit": "utensils",
      "transport-benefit": "bus",
      "health-insurance-benefit": "user-md",
    }[str] || null);

  const icon = getIcon(category);
  return (
    <Grid container className={row} alignItems="center">
      <Grid xs={10} item>
        <Grid xs={10} item>
          {icon && (
            <Box className={iconBox}>
              <FontAwesomeIcon icon={icon} className="icon icon-primary" />
            </Box>
          )}
          {date} {text}
        </Grid>
      </Grid>
      <Grid xs={2} item container justify="space-between">
        <Grid>{t("common-messages.amount")}: </Grid>
        <Grid>{price} EUR</Grid>
      </Grid>
    </Grid>
  );
};
PaymentRow.propTypes = {
  category: PropTypes.string.isRequired,
  text: PropTypes.string,
  price: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
};

PaymentRow.defaultProps = {
  text: "",
};
